import { ca } from '@cian/analytics';
import { INewbuildingRecommendations } from '../../types/newbuilding_recommendations';

function mapRecommendedNewbuildingToProduct(recommendedNewbuilding: INewbuildingRecommendations, index: number) {
  const product = {
    id: recommendedNewbuilding.id,
    position: index + 1,
    offerType: 'JK',
  };

  return product;
}

export function showRecommendedNewbuilding(recommendedNewbuildings: INewbuildingRecommendations[]) {
  ca('eventEbc', {
    action: 'show_similar_JK',
    category: `similar_objects`,
    label: '',
    name: 'oldevent',
    products: recommendedNewbuildings.map(mapRecommendedNewbuildingToProduct),
  });
}

export function openRecommendedNewbuilding(recommendedNewbuilding: INewbuildingRecommendations, index: number) {
  ca('eventEbc', {
    action: 'click_similar_JK',
    category: `similar_objects`,
    label: recommendedNewbuilding.fullUrl,
    name: 'oldevent',
    products: [mapRecommendedNewbuildingToProduct(recommendedNewbuilding, index)],
  });
}
